export default __webpack_public_path__ + "static/media/icon-coin-doge.55630ffd.svg";